import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DatasetsContainer from './DatasetsContainer';
import { resetNewListBooleans } from '../../actions/data';
import { PROVIDER_ADMIN, PROVIDER_TECHNICAL } from '../../config/app_config';

const propTypes = {
  accountId: PropTypes.number.isRequired,
  isProviderAdmin: PropTypes.bool.isRequired,
  isTechnicalOps: PropTypes.bool.isRequired,
  resetBooleansAction: PropTypes.func.isRequired,
};

export const DataIndex = ({ accountId, isProviderAdmin, isTechnicalOps, resetBooleansAction }) => (
  <div className="modal-wrap">
    <div className="container-fluid container-home">
      <div className="header">
        <div className="header-body">
          <div className="row">
            <div className="col-md-12">
              <span className="pull-right">
                {isProviderAdmin || isTechnicalOps ? (
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      resetBooleansAction(accountId);
                    }}
                  >
                    New List
                  </button>
                ) : null}
              </span>
              <h1 className="header-title">Datasets</h1>
            </div>
          </div>
        </div>
      </div>
      <DatasetsContainer />
    </div>
  </div>
);

const mapStateToProps = state => {
  const { user, account } = state;
  const accountId = account.id;
  const isProviderAdmin = user.get('userTypeId') === PROVIDER_ADMIN;
  const isTechnicalOps = user.get('userTypeId') === PROVIDER_TECHNICAL;
  return {
    accountId,
    isProviderAdmin,
    isTechnicalOps,
  };
};

DataIndex.propTypes = propTypes;

export default connect(
  mapStateToProps,
  {
    resetBooleansAction: resetNewListBooleans,
  }
)(DataIndex);
